module.exports = __webpack_public_path__ + "img/06.e4e635ca.jpg";